import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import * as _ from "lodash";
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Rx';
import {PickupPointFee} from "./edit/pickup-point.fee";
import {FormControl} from "@angular/forms";
import {ValidatorService} from "../../core/validator.service";
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class PickupPointFeeService {

    private baseUrl: string = '../rest/company/';
    private endpoint:string = '/pickupPointFee';

    constructor(private http : Http, private translator:TranslateService) {}

    getData(companyId:number): any {
        return Observable.forkJoin([
            this.getOrigins(companyId),
            this.getAmountTypes(companyId),
            this.getCategory(companyId),
            this.getPaymentTypes(companyId),
            this.getFeeIdentifiers()
        ]);
    }

    getCategory(companyId:number): any {
        return this.http
            .get(`${this.baseUrl}${companyId}/pickupPointFee/categories`, { headers: this.getHeaders()})
            .map((response) => this.mapActions(response, 'fees.category.'));
    }

    getAmountTypes(companyId:number): any {
        return this.http
            .get(`${this.baseUrl}${companyId}/pickupPointFee/amountTypes`, { headers: this.getHeaders()})
            .map((response) => this.mapActions(response, 'fees.type.'));
    }

    getPaymentTypes(companyId:number): any {
        return this.http
            .get(`${this.baseUrl}${companyId}/pickupPointFee/paymentType`, { headers: this.getHeaders()})
            .map((response) => this.mapActions(response, 'fees.amount.'));
    }

    getFeeIdentifiers() {
        return this.http
            .get(`../rest/data/identifiers`, { headers: this.getHeaders()})
            .map((response: any) => {
                let identifiers = JSON.parse(response._body);
                if (Array.isArray(identifiers)) { 
                    return identifiers.map(identifier => { 
                        return { 
                            id: identifier.oid, // oid is assigned to id because selects need id field
                            oid: identifier.oid, 
                            version: identifier.version, 
                            name: identifier.name, 
                            value: identifier.name, // name is assigned to value because selects need value field
                            lang: identifier.lang }
                    });
                } else { return []; }
            });
    }

    createFeeIdentifiers(newIdentifiers: any): any {
        return this.http.post(`../rest/data/identifiers`, { identifiers: newIdentifiers });
    }

    getOrigins(companyId:number): any {
        return this.http
            .get(`${this.baseUrl}${companyId}/pickupPointFee/origins`, { headers: this.getHeaders()})
            .map((response) => this.mapActions(response, 'fees.applyTo.'));
    }

    public mapActions(response:Response, message): string[]{
        let body = response.json();
        return _.map(body, (item) => {return {id:item, value:message+item}}) || [];
    }

    private getHeaders(){
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        return myHeaders;
    }

    get(companyOid){
        return this.http
            .get(`${this.baseUrl}${companyOid}/pickupPointFee`, { headers: this.getHeaders()})
            .map((response) => <PickupPointFee[]>response.json());
    }

    getOne(companyOid, id){
        return this.http
            .get(`${this.baseUrl}${companyOid}/pickupPointFee/${id}`, { headers: this.getHeaders()})
            .map((response) => response.json());
    }

    save(fee: PickupPointFee, companyOid: number) {
        return this.http.post(`${this.baseUrl}${companyOid}/pickupPointFee`, fee);
    }

    update(fee: PickupPointFee, companyOid: number, id: string) {
        return this.http.put(`${this.baseUrl}${companyOid}/pickupPointFee/${id}`, fee);
    }

    remove(companyOid: number, id: string){
        return this.http.delete(`${this.baseUrl}${companyOid}/pickupPointFee/${id}`);
    }


    buildPickupsMap(pointsOfSale: any, additionals: any, context: any) {
        _.forEach(pointsOfSale, function (item) {
            context.pickupsMap[item.officePoint.oid] = item.officePoint.name;
        });

        _.forEach(additionals, function (item) {
            context.pickupsMap[item.oid] = item.name;
        });
    }

    positiveValueWrapper(c: FormControl){
        return ValidatorService.positiveValue(c) ? null : {
            feeAmount: {
                valid: false
            }
        };
    }

    notEmptyListWrapper(c: FormControl) {
        return ValidatorService.notEmptyList(c) ? null : {
            oids: {
                valid: false
            }
        };
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pickuppointfee/pickup-point-fee.service.ts